import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchStreamInfo = () => api.get("/stream-info").then((r) => r.data);

export const sendDM = (payload) => api.post("/messages", payload).then((r) => r.data);

export const fetchChat = () => api.get("/chat").then((r) => r.data);
export const sendChat = (payload) => api.post("/chat", payload).then((r) => r.data);

export const adminListMessages = (key) =>
    api.get(`/messages`, { params: { key } }).then((r) => r.data);
export const adminToggleAnswered = (id, answered, key) =>
    api
        .patch(`/messages/${id}`, null, { params: { answered, key } })
        .then((r) => r.data);
export const adminDeleteMessage = (id, key) =>
    api.delete(`/messages/${id}`, { params: { key } }).then((r) => r.data);
export const adminStats = (key) =>
    api.get(`/messages/stats`, { params: { key } }).then((r) => r.data);

export const fetchClips = () => api.get("/clips").then((r) => r.data);
export const incrementClipView = (id) =>
    api.post(`/clips/${id}/view`).then((r) => r.data);
export const adminCreateClip = (payload, key) =>
    api.post(`/clips`, payload, { params: { key } }).then((r) => r.data);
export const adminDeleteClip = (id, key) =>
    api.delete(`/clips/${id}`, { params: { key } }).then((r) => r.data);

// Ledger
export const ledgerSignup = (handle) =>
    api.post("/ledger/signup", { handle }).then((r) => r.data);
export const ledgerGet = (id) =>
    api.get(`/ledger/${id}`).then((r) => r.data);
export const ledgerCheckin = (id) =>
    api.post(`/ledger/${id}/checkin`).then((r) => r.data);
export const ledgerShare = (id) =>
    api.post(`/ledger/${id}/share`).then((r) => r.data);
export const ledgerLeaderboard = () =>
    api.get("/ledger/leaderboard").then((r) => r.data);
export const ledgerTopOfWeek = () =>
    api.get("/ledger/top-of-week").then((r) => r.data);

// Admin Comms Hub
export const adminFeed = (key) =>
    api.get("/admin/feed", { params: { key } }).then((r) => r.data);
export const adminChatReply = (payload, key) =>
    api.post("/admin/chat", payload, { params: { key } }).then((r) => r.data);
export const adminEmailDispatch = (payload, key) =>
    api.post("/admin/email", payload, { params: { key } }).then((r) => r.data);

// Q&A
export const fetchQuestions = () => api.get("/questions").then((r) => r.data);
export const fetchAnsweredQuestions = (limit = 20) =>
    api.get("/questions/answered", { params: { limit } }).then((r) => r.data);
export const submitQuestion = (payload) =>
    api.post("/questions", payload).then((r) => r.data);
export const voteQuestion = (id) =>
    api.post(`/questions/${id}/vote`).then((r) => r.data);
export const fetchFeaturedQuestion = () =>
    api.get("/questions/featured").then((r) => r.data);
export const adminFeatureQuestion = (id, key) =>
    api.post(`/admin/questions/${id}/feature`, null, { params: { key } }).then((r) => r.data);
export const adminClearOverlay = (key) =>
    api.post("/admin/questions/clear-overlay", null, { params: { key } }).then((r) => r.data);
export const adminAnswerQuestion = (id, answered, key) =>
    api.post(`/admin/questions/${id}/answered`, null, { params: { answered, key } }).then((r) => r.data);
export const adminDeleteQuestion = (id, key) =>
    api.delete(`/admin/questions/${id}`, { params: { key } }).then((r) => r.data);
